import { CustomFont } from 'stores/CustomFonts/CustomFont'
import { useRootStore } from 'stores/RootStore'
import { FontWeightType } from '../Types'

interface FontConfig {
  fontFamily: string
  weight: number
  italic: boolean
}

type SanitisedFontConfig = {
  fontFamily: string
  weight: FontWeightType
  italic: boolean
}

export const useSanitiseFontConfig = (): ((config: FontConfig) => SanitisedFontConfig) => {
  const { fonts } = useRootStore()

  return (config: FontConfig) => {
    const { fontFamily, italic } = config
    const weight = config.weight as FontWeightType

    const font = fonts.get(fontFamily)

    if (!font) {
      return {
        fontFamily,
        weight,
        italic,
      }
    }

    if (font instanceof CustomFont) {
      return {
        fontFamily,
        weight: font.weight as FontWeightType,
        italic,
      }
    }

    if (italic) {
      if (font.italicWeights.includes(weight)) {
        return {
          fontFamily,
          weight: weight as FontWeightType,
          italic,
        }
      }

      if (font.italicWeights.includes(400)) {
        return {
          fontFamily,
          weight: 400 as FontWeightType,
          italic,
        }
      }

      if (font.italicWeights.length > 0) {
        return {
          fontFamily,
          weight: font.italicWeights[0] as FontWeightType,
          italic,
        }
      }

      if (font.weights.includes(400)) {
        return {
          fontFamily,
          weight: 400 as FontWeightType,
          italic: false,
        }
      }

      return {
        fontFamily,
        weight: font.weights[0] as FontWeightType,
        italic: false,
      }
    }

    if (font.weights.includes(weight)) {
      return {
        fontFamily,
        weight: weight as FontWeightType,
        italic: false,
      }
    }

    if (font.weights.includes(400)) {
      return {
        fontFamily,
        weight: 400 as FontWeightType,
        italic: false,
      }
    }

    if (font.weights.length > 0) {
      return {
        fontFamily,
        weight: font.weights[0] as FontWeightType,
        italic: false,
      }
    }

    if (font.italicWeights.includes(400)) {
      return {
        fontFamily,
        weight: 400 as FontWeightType,
        italic: true,
      }
    }

    if (font.italicWeights.length > 0) {
      return {
        fontFamily,
        weight: font.italicWeights[0] as FontWeightType,
        italic: true,
      }
    }

    return {
      fontFamily,
      weight: 400 as FontWeightType,
      italic: false,
    }
  }
}
